<template>
  <div
    v-if="passType"
    class="cart"
  >
    <h3 class="cart__title">
      Order Summary
    </h3>
    <div class="cart__item cart__item--pass-type">
      <h4 class="cart__item-title">
        {{ passType.name }}
      </h4>
      <div class="cart__item-price">
        {{ passType.price | currency }}
      </div>
      <router-link
        v-if="!order.complete && $store.state.passTypes.length > 1"
        :to="{ name: 'pass' }"
        @click.native="unsetDiscountEligibilityType"
      >
        Change Pass
      </router-link>
    </div>
    <div
      v-if="registration.fullfillCard"
      class="cart__item cart__item--card"
    >
      <h4 class="cart__item-title">
        {{ $t("payment-request.card") }}
      </h4>
      <div class="cart__item-price">
        {{ passType.cardCost || 0 | currency }}
      </div>
      <button
        v-if="!order.complete"
        @click.prevent="removeCard"
      >
        Remove
      </button>
    </div>
    <div
      v-if="typeof promotionCode.code !== 'undefined'"
      class="cart__item cart__item--discount"
    >
      <h4 class="cart__item-title">
        Promo Code {{ promotionCode.displayCode }}
      </h4>
      <div class="cart__item-price">
        -{{ passType.price - promotionCode.discountedPassCost || 0 | currency }}
      </div>
      <button
        v-if="!order.complete"
        class="button-link"
        @click.prevent="removePromoCode"
      >
        Remove
      </button>
    </div>
    <div
      v-if="passType.salesTax"
      class="cart__item cart__item--tax"
    >
      <h4 class="cart__item-title">
        Sales Tax
      </h4>
      <div class="cart__item-price">
        {{ salesTax | currency }}
      </div>
    </div>
    <div class="cart__item cart__item--total">
      <h4 class="cart__item-title">
        Total
      </h4>
      <div class="cart__item-price">
        {{ totalCost | currency }}
      </div>
    </div>
    <PromoCode class="cart__item cart__item--promocode" />
    <div
      v-if="passType.fees"
      class="cart__fees"
    >
      <h3 class="cart__fees__title">
        How Usage Fees Work
      </h3>
      <div>
        <div
          class="cart__fees__content"
          v-html="passType.fees"
        />
      </div>
    </div>
  </div>
</template>
<script>
import PromoCode from './PromoCode.vue';

export default {
  components: { PromoCode },
  computed: {
    order() {
      return this.$store.state.order;
    },
    registration() {
      return this.$store.state.registration;
    },
    promotionCode() {
      return this.$store.state.promotionCode;
    },
    passType() {
      return this.$store.getters.passType;
    },
    salesTax() {
      return this.$store.getters.salesTax;
    },
    totalCost() {
      return this.$store.getters.totalCost;
    },
    systemId() {
      return this.$store.state.systemId;
    },
  },
  methods: {
    removeCard() {
      this.$store.dispatch('updateRegistration', { fullfillCard: false });
    },
    removePromoCode() {
      this.$store.dispatch('updatePromotionCode', {});
    },
    unsetDiscountEligibilityType() {
      this.$store.dispatch('updateRegistration', {
        discountEligibilityType: null,
      });
    },
  },
};
</script>
